import { createContext, useContext, useEffect, useState } from 'react';
import { AuthStore } from './auth';
import { getAllProfiles } from '../services/profiles';

export type FamilyMembersState = {
 familyMembers:Array<any>,
  getFamilyMembers:()=>any[],
  addFamilyMember:()=>void,

};

export const FamilyMembersStore = createContext<any>({
  familyMembers: [],
  getFamilyMembers:()=>{
    return []
  },
  addFamilyMember:()=> {},
});

const { Provider } = FamilyMembersStore;

export const FamilyMembersProvider = ({ children }: any) => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];

  const [familyMembers,setFamilyMembers] = useState<any[]>([]);


  const getFamilyMembers = ()=>{
    return getAllProfiles().data.filter(
      (profile) => profile.relationship !== 'self'
    );
  }

  const addFamilyMember = (familyMember:any) =>{
    const famMember = {
      address:{
        address1:familyMember.address1,
        address2:familyMember.address2,
        city:familyMember.city,
        state:familyMember.state,
        zipcode:familyMember.zipcode,
      },
      name:`${familyMember.firstName} ${familyMember.lastName}`,
      age:familyMember.age,
      covers:[''],
      dateOfBirth: new Date(familyMember.dob),
      id:familyMembers.length+1,
      ...familyMember,
      value:`user-${familyMember.length+1}`,
      gender:+familyMember.gender === 1?'female':+familyMember.gender === 2?'male':'d',
      isActionRequired: true,
      isVerified: false
    }
    const famMembers:any[] =familyMembers
    famMembers.push(famMember);

    setFamilyMembers(
      famMembers
    )
  }

  useEffect(() => {
    setFamilyMembers(
     getFamilyMembers()
    );
  }, []);

  return <Provider value={{familyMembers,getFamilyMembers,addFamilyMember}}>{children}</Provider>;
};
